import { InfoRounded } from '@mui/icons-material';
import { Box, Fade, Tooltip } from '@mui/material';

import { EpisodeRelevanceTooltip } from '@/components';
import { EpisodeCard as EpisodeCardType, Referrer } from '@/types';

import {
  EpisodeCard,
  EpisodeCardGutterSpacing,
  EpisodeCardVariants,
} from '../EpisodeCard';

interface EpisodeCardWrapperProps {
  inView: boolean;
  episode?: EpisodeCardType;
  index: number;
  variant: (typeof EpisodeCardVariants)[keyof typeof EpisodeCardVariants];
  stretch?: boolean;
  referrer: Referrer;
  uKey: string;
  isLoading?: boolean;
  showTooltip?: boolean;
}

export const EpisodeCardWrapper = ({
  inView,
  episode,
  index,
  variant,
  stretch,
  referrer,
  uKey,
  isLoading,
  showTooltip = false,
}: EpisodeCardWrapperProps) => {
  return (
    <Fade in={inView} timeout={Math.log10(index + 2) * 1000}>
      <Box sx={{ mr: EpisodeCardGutterSpacing[variant], position: 'relative' }}>
        {showTooltip && !!episode?.relevance && (
          <Box
            onClick={e => e.stopPropagation()}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              zIndex: 10,
              color: 'grey50',
            }}>
            <Tooltip
              title={<EpisodeRelevanceTooltip relevance={episode.relevance} />}>
              <InfoRounded />
            </Tooltip>
          </Box>
        )}
        <EpisodeCard
          variant={variant}
          episode={episode}
          stretch={stretch}
          referrer={{
            ...referrer,
            carousel: uKey,
            position: index + 1,
            ...(episode?.relevance
              ? { episodeRelevanceBoost: episode.relevance.totalBoost }
              : {}),
          }}
          isLoading={isLoading}
        />
      </Box>
    </Fade>
  );
};
